<div *ngIf="!books">
  <app-loading-spinner></app-loading-spinner>
</div>
<div *ngIf="books">
  <app-navbar></app-navbar>
  <app-recently-added
    [title]="' New Books   '"
    [cards]="books"
  ></app-recently-added>
  <div class="container">
    <h1>{{ title | uppercase }}!</h1>

    <div class="row">
      <div
        class=" col-lg-4 col-md-6 col-sm-12"
        *ngFor="let book of books; let i = index"
      >
        <mdb-card class="card">
          <div class="view rgba-white-slight waves-light" mdbWavesEffect>
            <!-- Card img -->
            <img class="card-img" [src]="book.image" alt="Card image cap" />
            <a [routerLink]="['book', book.id]">
              <div class="mask"></div>
            </a>
          </div>
          <!--Card content-->
          <mdb-card-body>
            <!--Title-->
            <mdb-card-title>
              <h4>{{ book.title | uppercase }}</h4>
            </mdb-card-title>

            <!--Text-->
            <mdb-card-text>
              {{ book.description }}
            </mdb-card-text>
            <mdb-card-title>
              <h4>Book rate : {{ book.rate }}</h4>
            </mdb-card-title>
          </mdb-card-body>

          <div p-3 class="text-center mb-3">
            <i
              (click)="voted(book.id); frame.show()"
              [class]="book.isVoted ? 'fas fa-thumbs-up' : 'far fa-thumbs-up'"
              style="font-size: 35px; margin: 0 10px;"
            ></i>
            <i
              (click)="fav(book.id); frame.show()"
              [class]="book.isfav ? 'fas fa-heart' : 'far fa-heart'"
              style="font-size: 35px; margin: 0 10px;"
            ></i>
            <i
              (click)="reading(); frame.show()"
              [class]="
                isOnList ? 'fas fa-calendar-plus' : 'far fa-calendar-plus'
              "
              style="font-size: 35px; margin: 0 10px;"
            ></i>
          </div>
        </mdb-card>
      </div>

      <div
        mdbModal
        #frame="mdbModal"
        class="modal fade"
        id="frameModalTop"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
        (open)="onOpen()"
      >
        <div class="modal-dialog modal-notify modal-danger" role="document">
          <!--Content-->
          <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
              <p class="heading lead">Vote Book</p>

              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                (click)="frame.hide()"
              >
                <span aria-hidden="true" class="white-text">&times;</span>
              </button>
            </div>

            <!--Body-->
            <div class="modal-body">
              <div
                *ngIf="isVoted && !showAlert"
                class="text-center alert alert-success "
              >
                book voted
              </div>
              <div
                *ngIf="!isVoted && !showAlert"
                class="text-center alert alert-danger "
              >
                book not voted
              </div>
              <div
                *ngIf="isOnList && !showAlert"
                class="text-center alert alert-success "
              >
                book added to reading list
              </div>
              <div
                *ngIf="!isOnList && !showAlert"
                class="text-center alert alert-danger "
              >
                book remove to reading list
              </div>
              <div
                *ngIf="isfav && !showAlert"
                class="text-center alert alert-success"
              >
                book Add to Favorite Books
              </div>
              <div
                *ngIf="!isfav && !showAlert"
                class="text-center alert alert-danger "
              >
                book Remove Form Favorite Books
              </div>
              <div *ngIf="showAlert" class="text-center alert alert-info ">
                <h3>
                  only users can vote book please log in :)
                </h3>
              </div>
            </div>

            <!--Footer-->
            <div class="modal-footer justify-content-center">
              <a
                type="button"
                mdbBtn
                color="primary"
                class="waves-light"
                mdbWavesEffect
                (click)="frame.hide()"
              >
                save changes
                <mdb-icon fas icon="check" class="ml-1"></mdb-icon>
              </a>
              <a
                type="button"
                mdbBtn
                color="primary"
                outline="true"
                class="waves-effect"
                mdbWavesEffect
                (click)="frame.hide()"
                data-dismiss="modal"
                >cancel</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
